import { defineAbTest } from "libs/state/src/lib/ab-tests";

/** Temporary flag to gate flavour/texture preference questions in the signup flow. */
export const SUF_PREFERENCE_QUESTIONS = defineAbTest({
  key: "suf-preference-questions",
  durability: "none",
});
